export default __webpack_public_path__ + "static/media/Arrow_leftbrown.cad156a5.svg";